import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthModalService {
  private _show = new BehaviorSubject<boolean>(false);
  private _redirectUrl = '';

  /** Observable — subscribe in components to react to show/hide */
  show$ = this._show.asObservable();

  /** Opens the modal and remembers where the user tried to go */
  open(redirectUrl: string = '') {
    this._redirectUrl = redirectUrl;
    this._show.next(true);
  }

  close() {
    this._show.next(false);
  }

  get redirectUrl(): string {
    return this._redirectUrl;
  }
}
